export default __webpack_public_path__ + "static/media/inventory_selected.70c4b86b.svg";